
export default class DateTool {
  public static parseDate(date: string): Date {
    const parts = date.split('-');
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  // convert yyyy-mm-dd to mm/dd/yyyy
  public static toFriendlyFormatFromIsoFormatString(date: string | null): string {
    if (!date) {
      return '';
    }

    const parts = date.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  }

  // convert Date to mm/dd/yyyy
  public static toFriendlyFormatFromDate(date: Date | null): string {
    if (!date) {
      return '';
    }

    return DateTool.toFriendlyFormatFromIsoFormatString(DateTool.toIsoDateString(date));
  }

  public static subtractOneDay(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = this.parseDate(dateString);
    date.setDate(date.getDate() - 1);
    const isoDateString = DateTool.toIsoDateString(date);
    return DateTool.toFriendlyFormatFromIsoFormatString(isoDateString);
  }

  public static todayBackendDate(): string {
    return DateTool.toIsoDateString(new Date());
  }

  public static toIsoDateString(date: Date | null): string {
    return date ? date.toISOString().substring(0, 10) : '';
  }

  public static getAustinDate(): Date {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  }

  public static getAustinDateNoTimeComponent(): Date {
    const now = new Date(); // intentionally trims off time portion
    return new Date(new Date(now.getFullYear(), now.getMonth(), now.getDate()).toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  }
}
